"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ITypographyProps", {
  enumerable: true,
  get: function get() {
    return _Typography2.ITypographyProps;
  }
});
Object.defineProperty(exports, "Kind", {
  enumerable: true,
  get: function get() {
    return _Typography2.Kind;
  }
});
Object.defineProperty(exports, "Level", {
  enumerable: true,
  get: function get() {
    return _Typography2.Level;
  }
});
Object.defineProperty(exports, "ResponsiveLevel", {
  enumerable: true,
  get: function get() {
    return _Typography2.ResponsiveLevel;
  }
});
exports["default"] = void 0;
var _Typography = _interopRequireDefault(require("./Typography"));
var _Typography2 = require("./Typography.types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = _Typography["default"];